import {
  createClient,
  fetchExchange,
  ssrExchange,
} from '@urql/vue';
import { devtoolsExchange } from '@urql/devtools';

export const ssr = ssrExchange({ isClient: import.meta.client });

const getPartnerPortalClient = (domain: string) => createClient({
  url: `${domain}/v2/graphql/partner-portal`,
  preferGetMethod: false,
  fetchOptions: () => ({
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache',
    },
    credentials: 'include',
  }),
  exchanges: [
    devtoolsExchange,
    ssr,
    fetchExchange,
  ],
});

export default getPartnerPortalClient;
